import { useMemo } from 'react';
import { PathsManifest } from '@zg-rentals/paths-manifest';

export default (baseUrl: string) => {
  return useMemo(() => {
    const pathsManifest = new PathsManifest(baseUrl, 'zillow');
    return {
      paths: pathsManifest.getAllPaths(),
    };
  }, [baseUrl]);
};
